import { createFileRoute } from '@tanstack/react-router';
import { TransfersListPage } from '@/features/transfers-list/transfers-list-page.js';

/** الحوالات المبدئية (transfers.md section 7.6, KAN-58). */
export const Route = createFileRoute('/_app/transfers/drafts')({
  component: DraftsRoute,
});

function DraftsRoute(): React.JSX.Element {
  return <TransfersListPage draftsOnly />;
}
